import { ArticleImpact } from '../../types';

interface MarketImpactProps {
  impacts: ArticleImpact[];
}

const TARGET_LABELS: Record<ArticleImpact['target'], string> = {
  bitcoin: 'Bitcoin',
  ethereum: 'Ethereum',
  altcoins: 'Altcoins',
  institutional: 'Mercado institucional',
  regulation: 'Regulação',
};

const DIRECTION_STYLES: Record<ArticleImpact['direction'], { label: string; className: string; icon: string }> = {
  positivo: { label: 'Positivo', className: 'bg-green-100 text-green-800', icon: '▲' },
  neutro: { label: 'Neutro', className: 'bg-gray-100 text-gray-700', icon: '▬' },
  negativo: { label: 'Negativo', className: 'bg-red-100 text-red-800', icon: '▼' },
};

const CONFIDENCE_LABELS: Record<ArticleImpact['confidence'], string> = {
  baixa: 'confiança baixa',
  media: 'confiança média',
  alta: 'confiança alta',
};

const HORIZON_LABELS: Record<ArticleImpact['horizon'], string> = {
  curto: 'curto prazo',
  medio: 'médio prazo',
  longo: 'longo prazo',
};

/** Leitura editorial de impacto por ativo/categoria — não é recomendação. */
export const MarketImpact: React.FC<MarketImpactProps> = ({ impacts }) => {
  if (!impacts || impacts.length === 0) return null;

  return (
    <section className="bg-white border border-gray-200 rounded-xl p-6 mb-6">
      <h2 className="text-lg font-bold text-gray-900 mb-1">Impacto no mercado</h2>
      <p className="text-xs text-gray-400 mb-4">
        Leitura editorial do possível efeito da notícia. Não é recomendação de compra ou venda.
      </p>
      <div className="space-y-3">
        {impacts.map((impact) => {
          const direction = DIRECTION_STYLES[impact.direction];
          return (
            <div key={impact.id} className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
              <div className="flex items-center gap-2 sm:w-56 flex-shrink-0">
                <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-bold ${direction.className}`}>
                  {direction.icon} {direction.label}
                </span>
                <span className="font-semibold text-gray-800 text-sm">{TARGET_LABELS[impact.target]}</span>
              </div>
              <div className="text-sm text-gray-600 leading-relaxed">
                {impact.rationale}
                <span className="text-gray-400">
                  {' '}({CONFIDENCE_LABELS[impact.confidence]}, {HORIZON_LABELS[impact.horizon]})
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
